
// Галерея товара + лайтбокс. Вся инициализация обёрнута в функцию, которую можно
// вызывать повторно: при переключении варианта (or-variant-system.js) слайды/превью
// пересобираются в DOM и галерею нужно переинициализировать заново.
// Обработчики на постоянных элементах (стрелки, контейнеры, document/window)
// навешиваются с неймспейсом .orgogallery и снимаются перед повторной привязкой.
function orgoInitProductGallery() {
    let currentIndex = 0;
    const slides = $('.organo-republic-slide');
    const total = slides.length;
    let startX = 0;
    let currentX = 0;
    let isSwiping = false;
    let isDown = false;
    let startThumbX;
    let scrollLeft;
    let isDragged = false;

    // Генерация точек (очищаем от предыдущей инициализации)
    $('.organo-republic-dots').empty();
    for (let i = 0; i < total; i++) {
        $('.organo-republic-dots').append(`<span class="organo-republic-dot ${i === 0 ? 'active' : ''}"></span>`);
    }

    function updateGallery() {
        $('.organo-republic-slides').css('transform', `translateX(-${currentIndex * 100}%)`);
        $('.organo-republic-dot').removeClass('active').eq(currentIndex).addClass('active');
        // Highlight thumbnail
        $('.organo-republic-thumbnail').removeClass('active').eq(currentIndex).addClass('active');

        // Update gallery height based on current slide.
        // Если картинка слайда ещё не загрузилась, outerHeight = ~0 — не схлопываем
        // контейнер (фото "пропадает"), оставляем прежнюю высоту до события load ниже.
        const currentSlide = slides.eq(currentIndex);
        const slideHeight = currentSlide.outerHeight();
        if (slideHeight > 40) {
            $('.organo-republic-gallery').css('height', slideHeight + 'px');
        }
    }

    // Пересчитываем высоту, когда изображения слайдов догружаются
    // (актуально после пересборки галереи при смене варианта)
    $('.organo-republic-slides img').off('load.orgogallery').on('load.orgogallery', function () {
        updateGallery();
    });

    // Arrow controls
    $('.organo-republic-arrow.right').off('click.orgogallery').on('click.orgogallery', () => {
        currentIndex = (currentIndex + 1) % total;
        updateGallery();
    });

    $('.organo-republic-arrow.left').off('click.orgogallery').on('click.orgogallery', () => {
        currentIndex = (currentIndex - 1 + total) % total;
        updateGallery();
    });

    // Dot controls (точки пересоздаются каждую инициализацию — дублей не будет)
    $('.organo-republic-dot').on('click', function(){
        currentIndex = $(this).index();
        updateGallery();
    });

    // Touch swipe for mobile
    $('.organo-republic-slides')
        .off('.orgogallery')
        .on('touchstart.orgogallery', function(e) {
            isSwiping = true;
            startX = e.touches[0].clientX;
            currentX = startX;
        })
        .on('touchmove.orgogallery', function(e) {
            if (!isSwiping) return;
            currentX = e.touches[0].clientX;
            const diff = startX - currentX;
            // Move slides during swipe
            $('.organo-republic-slides').css('transform', `translateX(calc(-${currentIndex * 100}% - ${diff}px))`);
        })
        .on('touchend.orgogallery', function() {
            if (!isSwiping) return;
            isSwiping = false;

            const diff = startX - currentX;
            const threshold = 50; // Minimum swipe distance to change slide

            if (diff > threshold && currentIndex < total - 1) {
                // Swipe left - next slide
                currentIndex++;
            } else if (diff < -threshold && currentIndex > 0) {
                // Swipe right - previous slide
                currentIndex--;
            }

            // Animate to final position
            updateGallery();
        });

    // Thumbnails drag and click
    const $thumbnails = $('.organo-republic-thumbnails');
    if ($thumbnails.length) {
        $thumbnails.off('.orgogallery');

        $thumbnails.on('mousedown.orgogallery', function(e) {
            isDown = true;
            isDragged = false;
            $thumbnails.addClass('active');
            startThumbX = e.pageX - $thumbnails.offset().left;
            scrollLeft = $thumbnails.scrollLeft();
        });

        $thumbnails.on('mouseleave.orgogallery', function() {
            isDown = false;
            $thumbnails.removeClass('active');
        });

        $thumbnails.on('mouseup.orgogallery', function() {
            isDown = false;
            $thumbnails.removeClass('active');
        });

        $thumbnails.on('mousemove.orgogallery', function(e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - $thumbnails.offset().left;
            const walk = (x - startThumbX) * 2; // Scroll speed
            $thumbnails.scrollLeft(scrollLeft - walk);
            if (Math.abs(x - startThumbX) > 5) isDragged = true;
        });

        $('.organo-republic-thumbnail').off('click.orgogallery').on('click.orgogallery', function(e) {
            if (isDragged) {
                e.preventDefault();
                return;
            }
            currentIndex = $(this).index();
            updateGallery();
        });
    }

    // Initial update and set initial height
    updateGallery();

    // Update height on window resize
    $(window).off('resize.orgogallery').on('resize.orgogallery', function() {
        updateGallery();
    });

    // ================= IMAGE LIGHTBOX / ZOOM =================
    const $lightbox = $('#organo-republic-lightbox');

    // Move the lightbox to the end of <body> so a sticky/positioned ancestor
    // (e.g. the sticky gallery column) can never trap its position:fixed box.
    if ($lightbox.length) {
        $lightbox.appendTo('body');
    }

    const $lightboxImage = $lightbox.find('[data-lightbox-image]');
    const $lightboxStage = $lightbox.find('[data-lightbox-stage]');
    const $lightboxCurrent = $lightbox.find('.organo-republic-lightbox__counter-current');
    const $lightboxThumbs = $lightbox.find('.organo-republic-lightbox__thumb');

    $lightbox.off('.orgogallery');
    $lightboxStage.off('.orgogallery');
    $(document).off('.orgogallery');

    if ($lightbox.length && total > 0) {
        const galleryImages = slides.map(function () {
            const $img = $(this).find('img');
            return {
                src: $img.attr('data-zoom-src') || $img.attr('src'),
                alt: $img.attr('alt') || ''
            };
        }).get();

        // Preload every full-size zoom image up front so swiping/navigating
        // in the lightbox is instant instead of waiting on a fresh download.
        const preloadedImages = {};
        function preloadImage(index) {
            const data = galleryImages[index];
            if (!data || !data.src || preloadedImages[data.src]) return;
            preloadedImages[data.src] = true;
            const img = new Image();
            img.src = data.src;
        }

        const scheduleIdle = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
        scheduleIdle(function () {
            for (let i = 0; i < galleryImages.length; i++) preloadImage(i);
        });

        let lightboxIndex = 0;
        let zoomScale = 1;
        let zoomX = 0;
        let zoomY = 0;
        const ZOOM_MAX = 4;
        const ZOOM_DOUBLE_TAP_SCALE = 2.5;

        function applyZoomTransform() {
            $lightboxImage.css('transform', 'translate(' + zoomX + 'px, ' + zoomY + 'px) scale(' + zoomScale + ')');
            $lightboxStage.toggleClass('is-zoomed', zoomScale > 1);
        }

        function resetZoom() {
            zoomScale = 1;
            zoomX = 0;
            zoomY = 0;
            applyZoomTransform();
        }

        function renderLightboxSlide(index) {
            const data = galleryImages[index];
            if (!data) return;
            $lightboxImage.attr('src', data.src).attr('alt', data.alt);
            $lightboxCurrent.text(index + 1);
            $lightboxThumbs.removeClass('active').eq(index).addClass('active');
            resetZoom();
            // Make sure the images on either side are already cached
            // by the time the visitor swipes or clicks an arrow.
            preloadImage((index + 1) % total);
            preloadImage((index - 1 + total) % total);
        }

        function openLightbox(index) {
            lightboxIndex = ((index % total) + total) % total;
            renderLightboxSlide(lightboxIndex);
            $lightbox.addClass('is-active').attr('aria-hidden', 'false');
            $('html').addClass('organo-republic-lightbox-open');
        }

        function closeLightbox() {
            $lightbox.removeClass('is-active').attr('aria-hidden', 'true');
            $('html').removeClass('organo-republic-lightbox-open');
            resetZoom();
            // Keep the main gallery in sync with whatever image was last viewed
            currentIndex = lightboxIndex;
            updateGallery();
        }

        function goToLightbox(step) {
            lightboxIndex = ((lightboxIndex + step) % total + total) % total;
            renderLightboxSlide(lightboxIndex);
        }

        function toggleZoomAt(clientX, clientY) {
            const rect = $lightboxStage[0].getBoundingClientRect();
            if (zoomScale > 1) {
                resetZoom();
            } else {
                zoomScale = ZOOM_DOUBLE_TAP_SCALE;
                zoomX = (rect.width / 2 - (clientX - rect.left)) * (zoomScale - 1) / zoomScale;
                zoomY = (rect.height / 2 - (clientY - rect.top)) * (zoomScale - 1) / zoomScale;
                applyZoomTransform();
            }
        }

        // Open trigger: tap/click directly on the main image
        $('.organo-republic-slide img').off('click.orgogallery').on('click.orgogallery', function (e) {
            e.preventDefault();
            openLightbox(currentIndex);
        });

        // Close triggers
        $lightbox.find('.organo-republic-lightbox__close').off('click.orgogallery').on('click.orgogallery', closeLightbox);

        $lightbox.on('click.orgogallery', function (e) {
            if (e.target === this) closeLightbox();
        });

        $lightboxStage.on('click.orgogallery', function (e) {
            if (e.target === this && zoomScale === 1) closeLightbox();
        });

        $lightbox.find('.organo-republic-lightbox__arrow--right').off('click.orgogallery').on('click.orgogallery', function () {
            goToLightbox(1);
        });
        $lightbox.find('.organo-republic-lightbox__arrow--left').off('click.orgogallery').on('click.orgogallery', function () {
            goToLightbox(-1);
        });

        $lightboxThumbs.off('click.orgogallery').on('click.orgogallery', function () {
            goToLightbox($(this).data('index') - lightboxIndex);
        });

        $(document).on('keydown.orgogallery', function (e) {
            if (!$lightbox.hasClass('is-active')) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowRight') goToLightbox(1);
            if (e.key === 'ArrowLeft') goToLightbox(-1);
        });

        // Desktop wheel zoom
        $lightboxStage.on('wheel.orgogallery', function (e) {
            if (!$lightbox.hasClass('is-active')) return;
            e.preventDefault();
            const delta = e.originalEvent.deltaY < 0 ? 0.25 : -0.25;
            zoomScale = Math.min(ZOOM_MAX, Math.max(1, zoomScale + delta));
            if (zoomScale === 1) {
                zoomX = 0;
                zoomY = 0;
            }
            applyZoomTransform();
        });

        // Double-click to toggle zoom (desktop)
        $lightboxStage.on('dblclick.orgogallery', function (e) {
            toggleZoomAt(e.clientX, e.clientY);
        });

        // Drag to pan when zoomed (mouse)
        let isPanningMouse = false;
        let panStartX = 0;
        let panStartY = 0;

        $lightboxStage.on('mousedown.orgogallery', function (e) {
            if (zoomScale <= 1) return;
            isPanningMouse = true;
            panStartX = e.clientX - zoomX;
            panStartY = e.clientY - zoomY;
            $lightboxStage.addClass('is-panning');
        });
        $(document).on('mousemove.orgogallery', function (e) {
            if (!isPanningMouse) return;
            zoomX = e.clientX - panStartX;
            zoomY = e.clientY - panStartY;
            applyZoomTransform();
        });
        $(document).on('mouseup.orgogallery', function () {
            isPanningMouse = false;
            $lightboxStage.removeClass('is-panning');
        });

        // Touch: pinch-to-zoom, pan, double-tap, swipe-to-navigate
        let touchMode = null; // 'pinch' | 'pan' | 'swipe'
        let startDistance = 0;
        let startScale = 1;
        let startPanX = 0;
        let startPanY = 0;
        let touchStartX = 0;
        let touchStartY = 0;
        let lastTapAt = 0;

        function getTouchDistance(touches) {
            const dx = touches[0].clientX - touches[1].clientX;
            const dy = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }

        $lightboxStage.on('touchstart.orgogallery', function (e) {
            const touches = e.originalEvent.touches;
            if (touches.length === 2) {
                touchMode = 'pinch';
                startDistance = getTouchDistance(touches);
                startScale = zoomScale;
            } else if (touches.length === 1) {
                const now = Date.now();
                if (now - lastTapAt < 300) {
                    toggleZoomAt(touches[0].clientX, touches[0].clientY);
                    lastTapAt = 0;
                    touchMode = null;
                    return;
                }
                lastTapAt = now;
                touchStartX = touches[0].clientX;
                touchStartY = touches[0].clientY;
                if (zoomScale > 1) {
                    touchMode = 'pan';
                    startPanX = touches[0].clientX - zoomX;
                    startPanY = touches[0].clientY - zoomY;
                } else {
                    touchMode = 'swipe';
                }
            }
        });

        $lightboxStage.on('touchmove.orgogallery', function (e) {
            const touches = e.originalEvent.touches;
            if (touchMode === 'pinch' && touches.length === 2) {
                e.preventDefault();
                const distance = getTouchDistance(touches);
                zoomScale = Math.min(ZOOM_MAX, Math.max(1, startScale * (distance / startDistance)));
                applyZoomTransform();
            } else if (touchMode === 'pan' && touches.length === 1) {
                e.preventDefault();
                zoomX = touches[0].clientX - startPanX;
                zoomY = touches[0].clientY - startPanY;
                applyZoomTransform();
            }
        });

        $lightboxStage.on('touchend.orgogallery', function (e) {
            if (touchMode === 'swipe') {
                const touch = e.originalEvent.changedTouches[0];
                const diffX = touchStartX - touch.clientX;
                const diffY = touchStartY - touch.clientY;
                if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY)) {
                    goToLightbox(diffX > 0 ? 1 : -1);
                }
            }
            if (zoomScale <= 1) {
                zoomX = 0;
                zoomY = 0;
                applyZoomTransform();
            }
            touchMode = null;
        });
    }
}

// Доступно для or-variant-system.js: переинициализация после пересборки слайдов
window.OrgoReinitProductGallery = orgoInitProductGallery;

// Липкие боковые колонки PDP (.or-col-1 / .or-col-3): колонка короче экрана
// липнет верхом (top:0), длиннее экрана — сначала долистывается до своего низа
// и только потом прилипает (отрицательный top). Высоты меняются при загрузке
// картинок и смене варианта, поэтому пересчёт через ResizeObserver.
(function () {
    var cols = document.querySelectorAll('.or-col-1, .or-col-3');
    if (!cols.length) return;

    function updateStickyTop() {
        cols.forEach(function (col) {
            col.style.top = Math.min(0, window.innerHeight - col.offsetHeight) + 'px';
        });
    }

    var ro = new ResizeObserver(updateStickyTop);
    cols.forEach(function (col) { ro.observe(col); });
    window.addEventListener('resize', updateStickyTop);
    updateStickyTop();
})();

$(function(){
    orgoInitProductGallery();
});
